<template>

  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-sm-8">
        <h2>{{ title }}</h2>
        <ol class="breadcrumb">
          <li v-for="item in path" :key="item.path"> <a @click.prevent="go(item)"> {{ pathName(item) }} </a> </li>
          <li class="active"> <strong> {{ action }} </strong> </li>
        </ol>
      </div>
      <div class="col-sm-4">
        <div class="title-action" v-if="isVisible">
          <button class="btn btn-w-m btn-success" @click="checkUserPermissions(btnTxt, btnLink)">{{ btnTxt }}</button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { permissions } from '../../mixins/permissions'
import { toast } from '../../mixins/toast'
import { mapGetters } from 'vuex'

export default {
  mixins: [ permissions, toast ],
  props: ['title', 'action', 'btnTxt', 'btnLink'],
  data() {
    return {
      path: [],
      isVisible: this.btnTxt && this.btnLink
    };
  },
  methods: {
    ...mapGetters(['getCompany']),

    checkUserPermissions(btnTxt, btnLink) {
      if(btnLink === '$back') { this.$router.go(-1); return }
      let perm = btnTxt == 'Incluir Usuário' ? '545697e894825c828956e7ce887791a4' : '2e39d305f43aa421df0c1c6ff28afa66'
      this.checkPermissions(this.getCompany().public_key, perm, btnTxt).then((isPermited) => {
        if(isPermited) {
          this.$router.push({ path: btnLink })
        }
      })
    },

    go(item) {
      if(item.path === this.$route.path) {
        this.$router.push({ path: item.path, query: this.$route.query, params: this.$route.params })
      } else {
        this.$router.push(item.path)
      }
    },

    pathName(path) { return path.meta.breadcrump || path.path.substr(1) }

  },
  mounted() {
    let fullPath = ''
    this.path = this.$route.path.substr(1).split('/').map((pathName) => {
      fullPath += `/${pathName}`
      return this.$router.resolve({ path: fullPath }).route
    })
  }
}
</script>

<style scoped>
  .breadcrumb li:hover { font-weight: bold; }
</style>



// WEBPACK FOOTER //
// src/components/layout/BreadCrumps.vue